"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const i18n_js_1 = __importDefault(require("i18n-js"));
const styled_components_1 = __importDefault(require("styled-components"));
const material_1 = require("@mui/material");
const decorators_1 = require("../../../../common/decorators");
const TuiChatModal = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-evenly;
  height: 100%;
  padding: 16px;
  overflow: auto;

  ul {
    list-style-type: inside;
    padding-left: revert;

    li {
      list-style-type: disc;
    }
  }

  p {
    margin: 0;
  }

  ul,
  p {
    font-size: 18px;
  }

  .close-btn {
    width: 40%;
  }
`;
const TextContainer = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 90%;
`;
const TUIChatModal = ({ onClose, showChatIntroModal, currentLocale }) => {
    const isGerman = currentLocale === 'de' || currentLocale === 'derobinson';
    return (react_1.default.createElement(TuiChatModal, null,
        react_1.default.createElement(TextContainer, null,
            react_1.default.createElement("p", null, isGerman
                ? 'Wussten Sie, dass unsere BLUE® App eine noch bessere Möglichkeit bietet, mit unseren Sensatori Experts in Kontakt zu treten und Ihren Aufenthalt zu gestalten? Lassen Sie sich diese exklusiven Vorteile nicht entgehen:'
                : "Did you know that our BLUE® App offers an even better way to connect with our Sensatori Experts and manage your stay? Don't miss out on these exclusive benefits:"),
            isGerman ? (react_1.default.createElement("ul", null,
                react_1.default.createElement("li", null, "Sofortiger Chat mit unserem Sensatori-Team"),
                react_1.default.createElement("li", null, "Einfacher Zugang zu Ihren Buchungsdetails"),
                react_1.default.createElement("li", null, "Aktualisierungen und Benachrichtigungen in Echtzeit"),
                react_1.default.createElement("li", null, "Personalisierte Empfehlungen f\u00FCr Aktivit\u00E4ten und Restaurants"),
                react_1.default.createElement("li", null, "Exklusive Angebote und Rabatte in der App"))) : (react_1.default.createElement("ul", null,
                react_1.default.createElement("li", null, "Instant chat with our Sensatori team"),
                react_1.default.createElement("li", null, "Easy access to your booking details"),
                react_1.default.createElement("li", null, "Real-time updates and notifications"),
                react_1.default.createElement("li", null, "Personalized recommendations for activities and dining "),
                react_1.default.createElement("li", null, "Exclusive app-only offers and discounts"))),
            react_1.default.createElement("p", null, isGerman
                ? ' Laden Sie die BLUE® App jetzt aus dem entsprechenden App-Store herunter und entdecken Sie eine Welt vollerMöglichkeiten. Machen Sie noch heute das Beste aus Ihrem Sensatori-Erlebnis.'
                : "Download the BLUE® App now from your device's app store and unlock a world of convenience at your fingertips. Make the most of your Sensatori experience today.")),
        react_1.default.createElement(material_1.Button, { className: "close-btn", variant: "contained", size: "large", role: "button", onClick: () => {
                onClose();
                showChatIntroModal();
            } }, i18n_js_1.default.t('close'))));
};
const mapStateToProps = store => ({
    currentLocale: store.getValue('currentLocale'),
});
exports.default = (0, decorators_1.withStore)(mapStateToProps)(TUIChatModal);
